import React, { useState } from 'react';

import { CourseEntity } from 'Models/Entities';

import { RequisiteWarning } from 'Queries/Hooks/StudyPlan/types';

import CourseInfoModal from 'Views/Pages/Frontend/StudyPlanWizard/CourseInfoModal';
import ChipGroup from 'Views/Components/Chip/ChipGroup';
import Chip from 'Views/Components/Chip/Chip';
import { kebabCase, toLength, toLower } from 'lodash';
import InfoIconButton from 'Views/Components/InfoIconButton/InfoIconButton';
import { BannerItem } from 'Views/Components/Accordion';

interface CourseListItemProps {
	course: CourseEntity;
	requisiteWarnings: RequisiteWarning[];
	componentNames: string[],
}

const CourseListItem = ({ course, requisiteWarnings, componentNames }: CourseListItemProps) => {
	const [showCourseInfoModal, setShowCourseInfoModal] = useState(false);

	const topLevelLogicGroup = course.requisiteLogicGroups
		.find(logicGroup => logicGroup.isTopLevelGroup);

	const hasRequisiteWarnings = requisiteWarnings?.length > 0;

	// show requisite description if there's no requisite warnings
	const requisiteDescription = !hasRequisiteWarnings && topLevelLogicGroup?.description?.length
		? (
			<div className="requisite-description">
				{topLevelLogicGroup?.description}
			</div>
		)
		: null;

	return (
		<div className="study-plan-course">
			<div className="course-details">
				<div>
					<p className="label">
						{course.code}{' '}
						<span className="course-name">
							{course.name}
						</span>
					</p>
					{requisiteDescription}
				</div>
				<span className="component-chips">
					<ChipGroup>
						{
							componentNames.map(componentName => (
								<Chip chipLabel={componentName} key={kebabCase(componentName)} />
							))
						}
					</ChipGroup>
				</span>
				<div className="course-units">
					<p>
						{course.units} {toLower(window.lexicon.unitsShort)}
					</p>
				</div>
				<InfoIconButton
					onClick={() => setShowCourseInfoModal(true)}
					ariaLabel={`show ${course.name}`}
				/>
			</div>
			{
				hasRequisiteWarnings
					? (
						<div className="requisite-warnings">
							{requisiteWarnings
								.map(warning => (
									<BannerItem
										key={warning.id}
										id={course.id}
										title={warning.title}
										subtitle={warning.description}
										type="warning"
										showIcon
									/>
								))}
						</div>
					)
					: null
			}
			{showCourseInfoModal ? (
				<CourseInfoModal
					isOpen={showCourseInfoModal}
					courseId={course.id}
					onCloseModal={() => setShowCourseInfoModal(false)}
				/>
			) : null}
		</div>
	);
};

export default CourseListItem;
